import {
  GET_SERVICES,
  CREATE_SERVICES,
  DELETE_SERVICES,
  UPDATE_SERVICES,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

const INIT_STATE = {
  services: [],
  error: {},
  success: "",
};

const Services = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_SERVICES:
          return {
            ...state,
            services: action.payload.data,
            success: "",
            error: {},
          };
        case CREATE_SERVICES:
          return {
            ...state,
            success: "Sucessfully created services",
            error: {},
          };
        case UPDATE_SERVICES:
          return {
            ...state,
            success: "Sucessfully updated services",
            error: {},
          };
        case DELETE_SERVICES:
          return {
            ...state,
            success: "Sucessfully delete services",
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_SERVICES:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case CREATE_SERVICES:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case UPDATE_SERVICES:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case DELETE_SERVICES:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_SERVICES: {
      return {
        ...state,
      };
    }
    case CREATE_SERVICES: {
      return {
        ...state,
      };
    }
    case UPDATE_SERVICES: {
      return {
        ...state,
      };
    }
    case DELETE_SERVICES: {
      return {
        ...state,
      };
    }
    default:
      return { ...state };
  }
};

export default Services;
